export const TYPE ={
    STRING: "string",
    NUMBER: "number",
    ARRAY: "array",
    UNDEFINED: "undefined",
    BOOLEAN: "boolean",
};